// @flow
export { default, HorizontalWrapper } from './HorizontalLayout';



// WEBPACK FOOTER //
// ../react-lib/src/components/layouts/HorizontalLayout/index.js